module.exports = __webpack_public_path__ + "static/media/消息.91486ae9.svg";